export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
  'kanban_manage',
  'kanban_view',
  // Phase 2.8: novas permissions de notificacao (admin controla quem vira supervisor)
  'notification_watch_all_conversations',
  'notification_watch_voip_events',
  'notification_watch_mentions_account_wide',
  // SiteUp: granular screen-view permissions
  // permitem ao admin construir custom roles que veem (ou nao) cada modulo do sistema
  'tasks_view',
  'captain_view',
  'copilot_use',
  'copilot_execute_actions',
  'copilot_bulk_actions',
  'copilot_send_public_messages',
  'copilot_quick_mode',
  'copilot_manage_routines',
  'copilot_manage_tools',
  'copilot_view_audit',
  'copilot_delete',
  'copilot_manage_history',
  'ai_agents_view',
  'voip_view',
  'campaigns_view',
  'companies_view',
  'email_sequences_view',
  'flow_builder_view',
  'team_chat_view',
  'notifications_view',
];

// Lista enxuta usada por routes/sidebar pra permitir custom roles + admin + agent
// Util pra evitar repetir esses dois roles base em cada meta.permissions
export const SCREEN_VIEW_PERMISSIONS = {
  TASKS: 'tasks_view',
  CAPTAIN: 'captain_view',
  AI_AGENTS: 'ai_agents_view',
  VOIP: 'voip_view',
  CAMPAIGNS: 'campaigns_view',
  COMPANIES: 'companies_view',
  EMAIL_SEQUENCES: 'email_sequences_view',
  FLOW_BUILDER: 'flow_builder_view',
  TEAM_CHAT: 'team_chat_view',
  NOTIFICATIONS: 'notifications_view',
};

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  kanban: {
    count: 'kanbanCount',
    permissions: [...ROLES, 'kanban_view'],
  },
};
